/* src/app/private/components/client-package/create-client-package/create-client-package.component.scss */
/*# sourceMappingURL=create-client-package.component.css.map */
